<template>
  <div>
    <div class="toolbar">
      <el-input v-model="query.crewNumber" clearable placeholder="编码" style="width:160px" @keyup.enter.native="search" />
      <el-input v-model="query.crewName" clearable placeholder="名称" style="width:160px" @keyup.enter.native="search" />
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
    </div>

    <el-table :data="list" border v-loading="loading">
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="crewNumber" label="编码" width="140" />
      <el-table-column prop="crewName" label="名称" min-width="160" show-overflow-tooltip />
      <el-table-column label="班组长" width="160">
        <template slot-scope="{ row }">{{ row.leaderStaffName || '-' }}</template>
      </el-table-column>
      <el-table-column prop="memberCount" label="人数" width="80" align="center" />
      <el-table-column label="启用" width="80" align="center">
        <template slot-scope="{ row }">
          <el-tag v-if="row.active === '1'" size="mini" type="success">是</el-tag>
          <el-tag v-else size="mini" type="info">否</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row.crewId)">修改</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row.crewId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total"
      :page="page"
      :page-size="pageSize"
      :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage"
      @size-change="onSize"
    />

    <el-dialog :title="form.crewId ? '修改班组' : '新增班组'" :visible.sync="visible" width="560px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="编码" prop="crewNumber"><el-input v-model="form.crewNumber" /></el-form-item>
        <el-form-item label="名称" prop="crewName"><el-input v-model="form.crewName" /></el-form-item>
        <el-form-item label="班组长">
          <el-select v-model="form.leaderStaffId" clearable filterable style="width:100%">
            <el-option v-for="i in staffOptions" :key="i.staffId" :label="(i.staffNumber || '') + ' ' + (i.staffName || '')" :value="i.staffId" />
          </el-select>
        </el-form-item>
        <el-form-item label="成员">
          <el-select v-model="form.memberIds" multiple filterable clearable style="width:100%">
            <el-option v-for="i in staffOptions" :key="i.staffId" :label="(i.staffNumber || '') + ' ' + (i.staffName || '')" :value="i.staffId" />
          </el-select>
        </el-form-item>
        <el-form-item label="启用"><el-switch v-model="form.active" active-value="1" inactive-value="0" /></el-form-item>
        <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="2" /></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import { listCrew, getCrew, saveCrew, updateCrew, deleteCrew } from '../../api/crew'
import { selectStaff } from '../../api/staff'

function emptyForm() {
  return { crewId: '', crewNumber: '', crewName: '', leaderStaffId: '', memberIds: [], active: '1', remark: '' }
}

export default {
  name: 'MesCrewPage',
  components: { ListPagination },
  data() {
    return {
      query: { crewNumber: '', crewName: '' },
      list: [],
      total: 0,
      page: 1,
      pageSize: 20,
      loading: false,
      visible: false,
      saving: false,
      form: emptyForm(),
      rules: {
        crewNumber: [{ required: true, message: '编码不能为空', trigger: 'blur' }],
        crewName: [{ required: true, message: '名称不能为空', trigger: 'blur' }]
      },
      staffOptions: []
    }
  },
  created() { this.load() },
  methods: {
    indexMethod(index) { return (this.page - 1) * this.pageSize + index + 1 },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listCrew({
        currentPage: this.page,
        pageSize: this.pageSize,
        crewNumber: this.query.crewNumber,
        crewName: this.query.crewName
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    openEdit(id) {
      this.form = emptyForm()
      this.visible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
      selectStaff().then(res => { this.staffOptions = res.data || [] }).catch(() => {})
      if (!id) return
      getCrew(id).then(res => {
        const row = res.data || {}
        this.form = Object.assign(emptyForm(), row, { memberIds: row.memberIds || [] })
      })
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.saving = true
        const req = this.form.crewId ? updateCrew(this.form) : saveCrew(this.form)
        req.then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.load()
        }).finally(() => { this.saving = false })
      })
    },
    onDelete(id) {
      this.$confirm('确定删除？', '提示', { type: 'warning' }).then(() => {
        deleteCrew([id]).then(() => {
          this.$message.success('已删除')
          this.load()
        })
      }).catch(() => {})
    }
  }
}
</script>
